/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface EnrollmentFailed
 */
export interface EnrollmentFailed {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof EnrollmentFailed
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {Error}
     * @memberof EnrollmentFailed
     */
    error: Error | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof EnrollmentFailed
     */
    studentId?: ActorActivityRecordActorUserId | null;
}

/**
 * Check if a given object implements the EnrollmentFailed interface.
 */
export function instanceOfEnrollmentFailed(value: object): value is EnrollmentFailed {
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function EnrollmentFailedFromJSON(json: any): EnrollmentFailed {
    return EnrollmentFailedFromJSONTyped(json, false);
}

export function EnrollmentFailedFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrollmentFailed {
    if (json == null) {
        return json;
    }
    return {
        
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'error': json['error'],
        'studentId': json['studentId'] == null ? undefined : ActorActivityRecordActorUserIdFromJSON(json['studentId']),
    };
}

export function EnrollmentFailedToJSON(json: any): EnrollmentFailed {
    return EnrollmentFailedToJSONTyped(json, false);
}

export function EnrollmentFailedToJSONTyped(value?: EnrollmentFailed | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'error': value['error'],
        'studentId': ActorActivityRecordActorUserIdToJSON(value['studentId']),
    };
}

